import { render, staticRenderFns } from "./DashboardNavigationTabs.vue?vue&type=template&id=93281e44&scoped=true"
import script from "./DashboardNavigationTabs.vue?vue&type=script&lang=js"
export * from "./DashboardNavigationTabs.vue?vue&type=script&lang=js"
import style0 from "./DashboardNavigationTabs.vue?vue&type=style&index=0&id=93281e44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93281e44",
  null
  
)

export default component.exports